import { Box, Checkbox, FormControlLabel } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "../analyzeSlice";

export default function ActiveScenariosCheckbox() {
	const dispatch = useDispatch();
	const state = useSelector((store) => store.analyze);
	const clearScenario=[];
	const { isActiveScenario,scenariosFullData,scenariosData,selectedScenarioName,selectedDataProductIds,customerList,selectedScenarioID } = state;

	function handleCheck(event) {
		debugger;
		dispatch(setState("isActiveScenario", !isActiveScenario));
		console.log("isActiveScenario", !isActiveScenario);
		dispatch(setState("selectedScenarioName", ""));
		dispatch(setState("selectedScenarioID", ""));
		clearValues();
		
		if(!isActiveScenario)
		{
				const today=new Date();
				const todayStr=today.toISOString().split('T')[0];

				const activeScenario=scenariosFullData.filter(scenario=>{
					return todayStr>=scenario.effectiveStartDate && todayStr<=scenario.effectiveEndDate;
				});

				dispatch(setState("scenariosData",activeScenario));
		}
		else{
			dispatch(setState("scenariosData",scenariosFullData));
		}
	}

	const clearValues = () => {


		dispatch(setState("clearDataValues", true));
		dispatch(setState("scenariosData", clearScenario));
		dispatch(setState("selectedScenarioName", ""));
		dispatch(setState("selectedScenarioID", ""));
		dispatch(setState("selectedDataCustomerIds", []));
		dispatch(setState("customerList", []));
		dispatch(setState("selectedDataProductIds", []));
		dispatch(setState("skuPgsData", []));
		dispatch(setState("customersData", []));


	}

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				width: "100%",
				maxWidth: 220,
				mt: 0.5,
			}}
		>
			<FormControlLabel
				control={
					<Checkbox
						checked={isActiveScenario}
						onChange={handleCheck}
						inputProps={{ "aria-label": "Active scenarios only" }}
						size="small"
					/>
				}
				label="Active Scenarios Only"
				sx={{
					m: 0,
					ml: 0,
					mr: 0,
					gap: 0.5,
					alignItems: "center",
					"& .MuiFormControlLabel-label": {
						fontSize: "0.875rem",
						lineHeight: 1.2,
					},
				}}
			/>
		</Box>
	);
}
